<div class="file-upload-container">
  <form>
    <ion-card class="profilebody">
      <!-- header -->
      <ion-row class="header-row">
        <h3>{{ CONSTANTS.HEADER }}</h3>
        <img
          [src]="IMAGES.CLOSE"
          alt="close"
          (click)="closeFileUploadPopup()"
        />
      </ion-row>

      <!-- body -->
      <div
        class="file-upload-body"
        [ngClass]="{
          uploaded: [
            fileUploadStatus.SUCCESS,
            fileUploadStatus.FAILED,
          ].includes(uploadStatus),
          'in-progress': uploadStatus === fileUploadStatus.IN_PROGRESS,
        }"
      >
        <p
          class="title"
          [hidden]=""
          [ngClass]="{
            'title-hidden': uploadStatus === fileUploadStatus.SUCCESS,
          }"
        >
          {{ CONSTANTS.NOTE }} <span class="csv">{{ CONSTANTS.CSV }}</span>
          {{ CONSTANTS.OR }} <span class="csv">{{ CONSTANTS.TXT }}</span>
          @if (data.sci) {
            {{ CONSTANTS.OR }} <span class="csv">{{ CONSTANTS.XLS }}</span>
          }
        </p>
        <div class="dropzone" appDnd (fileDropped)="onFileDropped($event)">
          <input
            type="file"
            name=""
            id="fileDropRef"
            #fileDropRef
            (change)="fileBrowseHandler($event)"
            [accept]="acceptedFileTypes"
          />
          @if (returnFile.returnData.length === 0) {
            <ion-icon src="assets/note_add.svg" class="add-icon"></ion-icon>
            <h3 class="file-drop-title">{{ CONSTANTS.DRAG_FILE }}</h3>
            <div class="or-wrapper">
              <hr class="line" />
              <p class="text">{{ CONSTANTS.OR }}</p>
              <hr class="line" />
            </div>
            <ion-row class="custom-row ion-justify-content-center">
              <ion-button fill="block" class="upload-btn">
                {{ CONSTANTS.BROWSE_FILES }}
              </ion-button>
            </ion-row>
          } @else {
            <div class="file-container">
              @if (returnFile.fileName.endsWith(".txt")) {
                <ion-icon
                  src="assets/file-icon.svg"
                  class="csv-file-icon"
                ></ion-icon>
              } @else {
                <ion-icon
                  src="assets/csv-file.svg"
                  class="csv-file-icon"
                ></ion-icon>
              }
              <p class="file-name">{{ returnFile.fileName }}</p>
            </div>
          }
          @if (uploadStatus === fileUploadStatus.FAILED) {
            <div class="file-upload-error">
              <p class="message">
                {{ fileErrorMessage }}
              </p>
            </div>
          }
        </div>
      </div>

      <!-- footer -->
      @if (
        [fileUploadStatus.SUCCESS, fileUploadStatus.FAILED].includes(
          uploadStatus
        )
      ) {
        <ion-row class="footer-row ion-justify-content-between">
          <ion-button
            fill="outline"
            class="cancel-btn"
            (click)="cancel()"
            onkeypress="cancel()"
            >{{ CONSTANTS.CANCEL }}</ion-button
          >
          @if (uploadStatus === fileUploadStatus.SUCCESS) {
            <ion-button
              fill="fill"
              class="submit-btn"
              (click)="submit()"
              onkeypress="submit()"
              >{{ CONSTANTS.SUBMIT }}</ion-button
            >
          }
          @if (uploadStatus === fileUploadStatus.FAILED) {
            <ion-button
              fill="fill"
              class="submit-btn reupload-btn"
              (click)="tryAgain = true; fileDropRef.click()"
              onkeypress="
                tryAgain = true;
                fileDropRef.click();
              "
            >
              {{ tryAgain ? CONSTANTS.REUPLOAD : CONSTANTS.TRY_AGAIN }}
            </ion-button>
          }
        </ion-row>
      }
    </ion-card>
  </form>
</div>
